export enum UPI_INTENT {
  PHONEPE = "PHONEPE",
  GPAY = "GPAY",
  PAYTM = "PAYTM",
  CRED = "CRED",
  OTHERS = "OTHERS",
  BHIM = "BHIM",
  POP = "POP",
  NAVI = "NAVI",
  AMAZONPAY = "AMAZONPAY",
}
